import Content from 'components/common/Content-v2';
import MainTitle from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import AddGuideForm from 'components/forms/guides/add';
const AddMember = props => {
	return (
		<>
			<MainTitle>
				<h1>Añadir guía</h1>
				<LinkButton to="/admin/members"> Regresar </LinkButton>
			</MainTitle>
			<Content>
				<AddGuideForm />
			</Content>
		</>
	);
};
export default AddMember;
